const RightSideIcon = () => {
  return (
    <div className="right-side icon-right-primary">
      <i className="fa fa-usd"></i>
      <div className="shap-block">
        <div className="rounded-shap animate-bg-primary">
          <i></i>
          <i></i>
        </div>
      </div>
    </div>
  );
};

export default RightSideIcon;
